import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=7d65a1cc&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "./Manage.vue?vue&type=style&index=0&id=7d65a1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d65a1cc",
  null
  
)

export default component.exports